import { useLang } from "@/i18n";

// "from X € a night", shown next to the apartment's name when the owner ticks
// the option in the panel (Prezzi) and the apartment can be booked.
export default function FromPrice({ unit, className = "" }) {
  const { t } = useLang();
  if (!unit.fromPrice || !unit.bookable) return null;
  const [before, after] = t.unitPage.fromPrice.split("{price}");
  return (
    <p className={`text-sm text-stone ${className}`} data-testid={`from-price-${unit.slug}`}>
      {before}<span className="font-display text-2xl text-ink lining-nums">{unit.fromPrice}</span>{after}
    </p>
  );
}
